import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
  fill?: string;
}
const Toggle: React.FC<Props> = ({
  width = '36',
  height = '24',
  fill = 'white',
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect
        x="0.75"
        y="0.75"
        width="34.5"
        height="22.5"
        rx="11.25"
        stroke="white"
        strokeWidth="1.5"
      />
      <circle cx="24" cy="12" r="9" fill={fill} />
    </svg>
  );
};

export default Toggle;
